import { LanguageType } from '@/custom-types';
import { useUserLanguage } from '@/customHooks';
import { IncidentStatusOption } from '@/graphql/generated';

type IncidentStatusOptionPillProps = {
  option: IncidentStatusOption
}

const pillBase = 'inline-flex items-center justify-center rounded-full px-3 py-1 text-[0.7rem] font-bold'

const optionMapping = (option: IncidentStatusOption, language: LanguageType) => {
  const waitingStyle = { className: 'text-[#FF971D] bg-[#FF971D21]' };
  const newStyle = { className: 'text-[#ff7878] bg-[#ffd7d7]' };
  const completedStyle = { className: 'text-[#4a9462] bg-[#d2f3dc]' };
  const closedStyle = { className: 'text-[#808080] bg-[#ECECEC]' };

  const mapping: Record<
    LanguageType,
    Record<
      IncidentStatusOption,
      { text: string; className: string }
    >
  > = {
    en: {
      [IncidentStatusOption.New]: { text: 'New', ...newStyle },
      [IncidentStatusOption.Pending]: { text: 'Pending', ...waitingStyle },
      [IncidentStatusOption.Assigned]: { text: 'Assigned', ...waitingStyle },
      [IncidentStatusOption.Scheduled]: { text: 'Scheduled', ...waitingStyle },
      [IncidentStatusOption.Resolved]: { text: 'Resolved', ...completedStyle },
      [IncidentStatusOption.Completed]: { text: 'Completed', ...completedStyle },
      [IncidentStatusOption.Cancelled]: { text: 'Cancelled', ...closedStyle },
    },
    es: {
      [IncidentStatusOption.New]: { text: 'Nuevo', ...newStyle },
      [IncidentStatusOption.Pending]: { text: 'Pendiente', ...waitingStyle },
      [IncidentStatusOption.Assigned]: { text: 'Asignado', ...waitingStyle },
      [IncidentStatusOption.Scheduled]: { text: 'Programado', ...waitingStyle },
      [IncidentStatusOption.Resolved]: { text: 'Resuelto', ...completedStyle },
      [IncidentStatusOption.Completed]: { text: 'Completado', ...completedStyle },
      [IncidentStatusOption.Cancelled]: { text: 'Cancelado', ...closedStyle },
    },
  };

  return mapping[language][option];
};

export const IncidentStatusOptionPill = ({ option }: IncidentStatusOptionPillProps) => {
  const userLanguage = useUserLanguage()

  const optionMapped = optionMapping(option, userLanguage)
  return (
    <div className={`${pillBase} ${optionMapped.className}`}>
      {optionMapped.text}
    </div>
  );
}
